function Stats() {
  return <>Stats page</>;
}
export default Stats;
